import { Stack } from '@mui/material'
import { type FC } from 'react'
import { type CandidateFilterState } from 'shared/hooks/candidateSearchUrlState'
import {
    StarRatingFilter,
    ScreeningTypeFilter,
} from './CandidateMinimalFilters'

interface CandidateRatingFilterSectionProps {
    filters: CandidateFilterState
    updateFilters: (patch: Partial<CandidateFilterState>) => void
}

export const CandidateRatingFilterSection: FC<
    CandidateRatingFilterSectionProps
> = ({ filters, updateFilters }) => {
    return (
        <Stack gap={2.5} sx={{ p: 2 }}>
            <StarRatingFilter
                value={{
                    min: filters.starRatingMin,
                    max: filters.starRatingMax,
                }}
                onChange={(min, max) =>
                    updateFilters({
                        starRatingMin: min,
                        starRatingMax: max,
                    })
                }
            />
            <ScreeningTypeFilter
                templateIds={filters.screeningNoteTemplateIds}
                starMin={filters.screeningNoteStarRatingMin}
                starMax={filters.screeningNoteStarRatingMax}
                onChange={(
                    screeningNoteTemplateIds,
                    screeningNoteStarRatingMin,
                    screeningNoteStarRatingMax
                ) =>
                    updateFilters({
                        screeningNoteTemplateIds,
                        screeningNoteStarRatingMin,
                        screeningNoteStarRatingMax,
                    })
                }
            />
        </Stack>
    )
}
